import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';
import { AccountingDepositEntity } from '../../../../../../api/types/accounting/accounting-deposit-entity';

// Backend Joi enforces `DD_MM_YYYY_PATTERN` on the route. We format on the
// client to avoid a round-trip through the user's locale (which on certain
// machines emits MM/DD/YYYY and would always be rejected by the server).
const formatDateAsDdMmYyyy = (date: Date): string => {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = String(date.getFullYear());
  return `${day}/${month}/${year}`;
};

export const updateDepositDateOperation = async (
  depositId: number,
  newDate: Date,
  setLoading: (loading: boolean) => void,
  // Receives the freshly-updated deposit entity returned by the server, so the
  // caller can sync any locally-cached copy (e.g. the dialog's `loadedDeposit`)
  // without a follow-up GET.
  onSuccess: (updated: AccountingDepositEntity) => void,
) => {
  try {
    setLoading(true);

    const res = await appApi.updateAccountingDepositDate(
      depositId,
      formatDateAsDdMmYyyy(newDate),
    );

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    const updated = res.data.body;
    if (!updated) {
      toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
      setLoading(false);
      return;
    }

    toast.success('תאריך ההפקדה עודכן בהצלחה');
    setLoading(false);
    onSuccess(updated);
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
